// import { concat } from 'lodash';
import { PERMISSIONS_SUBSCRIBED_PLAN } from 'constants/permissions';

import { SCOPES } from 'constants/roles';

export default {
  label: 'label.health_box',
  name: 'workspace',
  url: '/professional/workspace',
  navigationIcon: 'far fa-box-full',
  type: 'section',
  scope: SCOPES.CREATOR,
  requiredSubscribedFeature: PERMISSIONS_SUBSCRIBED_PLAN.FOOD_ALLERGENS,
  // pages: concat(
  //   ProgramDiet,
  // ),
  pages: [
    {
      label: 'label.allergens',
      name: 'allergens-list',
      url: '/professional/workspace/allergens/',
      navigationIcon: 'far fa-allergies',
      scope: SCOPES.CREATOR,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/data/navigations/workspace/index.js